import { gql } from "../../../__generated__/gql";

export const GET_BANDS = gql(`
query bands($take: Int!, $skip: Int!, $where: BandWhereInput, $orderBy: [BandOrderByInput!]) {
  bandCount
  bands(skip:$skip, take: $take, where: $where, orderBy: $orderBy) {
    id
    name
    description
    imageUrl
    bookings {
      edition {
        id
        year
      }
      id
      date
      stage {
        name
      }
    }
  }
}
`);
